var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"shade-bg"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/icon/icon_loading_w.png")}}),_c('p',[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }